import { Approver, Status } from "../../enum/common";
import { getStatusTag } from "./FilterEnum";

export const isUserOperation = (operation: string, userOperation: string) => {
  return operation.includes(userOperation);
};

export const getApprover = (status: Status, approver: Approver) => {
  const map: Record<string, string> = {
    APPROVED_GIAM_DOC: "Giám đốc đã duyệt",
    APPROVED_QUAN_LY: "Quản lý đã duyệt",
    APPROVED_HR: "HR đã duyệt",
    REJECTED_GIAM_DOC: "Giám đốc từ chối",
    REJECTED_QUAN_LY: "Quản lý từ chối",
    REJECTED_HR: "HR từ chối",
  };

  return map[`${status}_${approver}`] ?? "Không xác định";
};

export const getDisplayStatus = (record: any) => {
  const isRejected =
    record.statusApprover === Status.REJECTED ||
    record.statusHr === Status.REJECTED ||
    record.statusDirection === Status.REJECTED;

  if (isRejected) {
    return {
      color: "error",
      label: "Từ chối",
    };
  }

  if (record.statusManager === Status.PENDING) {
    return {
      color: "processing",
      label: "Chờ quản lý duyệt",
    };
  }

  if (record.statusApprover === Status.PENDING) {
    return {
      color: "processing",
      label: "Chờ nhân sự duyệt",
    };
  }

  if (record.statusDirection === Status.PENDING) {
    return {
      color: "processing",
      label: "Chờ giám đốc duyệt",
    };
  }

  return getStatusTag(record.status);
};
